import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { forwardRef, useMemo } from 'react';
import { useComponentTheme } from '../../../theme/theme.context.esm.js';

var _excluded = ["canShrink", "children", "className", "direction", "fullHeight", "fullWidth", "gap", "gapCol", "gapRow", "justify", "padding", "paddingX", "paddingY", "scrollable"];
// import { usePropId } from '../../../utils/use-prop-id'

var CardBodyWrapper = /*#__PURE__*/forwardRef(function CardBodyWrapper(props, ref) {
  var theme = useComponentTheme('Card');
  var canShrink = props.canShrink,
    children = props.children,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'vertical' : _props$direction,
    fullHeight = props.fullHeight,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? true : _props$fullWidth,
    gap = props.gap,
    gapCol = props.gapCol,
    gapRow = props.gapRow,
    justify = props.justify,
    padding = props.padding,
    paddingX = props.paddingX,
    paddingY = props.paddingY,
    scrollable = props.scrollable,
    rest = _objectWithoutProperties(props, _excluded);
  // const id = usePropId(props.id)
  var classes = useMemo(function () {
    return theme.bodyWrapper({
      canShrink: canShrink,
      className: className,
      direction: direction,
      fullHeight: fullHeight,
      fullWidth: fullWidth,
      gap: gap,
      gapCol: gapCol,
      gapRow: gapRow,
      justify: justify,
      padding: padding,
      paddingX: paddingX,
      paddingY: paddingY,
      scrollable: scrollable
    });
  }, [canShrink, className, direction, fullHeight, fullWidth, gap, gapCol, gapRow, justify, padding, paddingX, paddingY, scrollable, theme]);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    // id={id}
    ref: ref,
    className: "csg-tw-card-body-wrapper ".concat(classes)
  }, rest), children);
});
CardBodyWrapper.displayName = 'Card.Body.Wrapper';
/**
 * Can be use when we need to introduce other elements that is a sibling of Card.Body
 */
var CardBodyWrapper$1 = CardBodyWrapper;

export { CardBodyWrapper$1 as default };
//# sourceMappingURL=card-body-wrapper.esm.js.map
